// import React, { useEffect, useState, forwardRef } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// // import { useTranslation } from "react-i18next"; // Removed as t() is no longer used for static text here
// import { toast } from "react-toastify";
// import {
//   Container,
//   Grid,
//   TextField,
//   Typography,
//   Divider,
//   Box,
//   Autocomplete,
//   Paper,
//   TableContainer,
//   Table,
//   TableHead,
//   TableBody,
//   TableRow,
//   TableCell,
//   IconButton,
//   CircularProgress,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Slide,
//   CssBaseline,
// } from "@mui/material";
// import { TransitionProps } from "@mui/material/transitions";
// import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import CloseIcon from "@mui/icons-material/Close";
// import FindInPageIcon from '@mui/icons-material/FindInPage';
// import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
// import NoSimIcon from '@mui/icons-material/NoSim';

// import HOST_URL from "../../../utils/Url";
// import ToastApp from "../../../ToastApp";
// import dayjs from "dayjs";
// import Flipbook from "./components/Flipbook";
// import { getSecureDevId } from "../../../utils/storageHelpers";
// // Define interface for table row data for better type safety
// interface DocFile {
//   docMid: number;
//   pdfName: string;
//   keywords: string;
//   entryDate: string;
//   subFtype: string;
//   pdfPath?: string;
// }

// // Define interface for the selected item from Autocomplete
// interface SelectedFileItem {
//   label: string;
//   value: number;
//   member_DocFiles: DocFile[];
// }

// // Dialog Transition
// const Transition = forwardRef(function Transition(
//   props: TransitionProps & {
//     children: React.ReactElement<any, any>;
//   },
//   ref: React.Ref<unknown>
// ) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

// type Props = {};

// const DocViewer = (props: Props) => {
//   // const { t } = useTranslation(); // Removed
//   const navigate = useNavigate();

//   const [fileOptions, setFileOptions] = useState<SelectedFileItem[]>([]);
//   const [selectedItem, setSelectedItem] = useState<SelectedFileItem | null>(null);
//   const [tableData, setTableData] = useState<DocFile[]>([]);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [selectedRowData, setSelectedRowData] = useState<DocFile | null>(null);
//   const [pdfShow, setPDFShow] = useState<string | null>(null);
//   const [isLoadingFiles, setIsLoadingFiles] = useState(false);
//   const [isLoadingPdf, setIsLoadingPdf] = useState(false);
//   const [toaster, setToaster] = useState(false); // Assuming ToastApp uses this - keep if needed by ToastApp

// const devId = getSecureDevId();


//   // Fetch File List on Mount
//   useEffect(() => {
//     fetchFileList();
//   }, []);

//   const fetchFileList = async () => {
//     setIsLoadingFiles(true);
//     const collectData = {
//       docMid: -1,
//       fileTypId: -1,
//       //@ts-ignore
//       divisionid:devId === "null" ? -1 : devId,
//       subsubjId: -1,
//       user_Id: -1,
//       fileNo: "",
//     };
//     try {
//       const response = await axios.post<{ data: any[] }>(
//         HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`,
//         collectData
//       );
//       const formattedOptions = response.data.data.map((item: any) => ({
//         label:item.fileNo ? `${item.fileNo} (${item.synopsis})` : "_ _",
//         value: item.docMid,
//         member_DocFiles: item.member_DocFiles || [],
//       }));
//       setFileOptions(formattedOptions);
//     } catch (error) {
//       console.error("Error fetching file list:", error);
//       // Still using toast for errors, but with hardcoded English text
//       toast.error("Failed to fetch file list.");
//     } finally {
//       setIsLoadingFiles(false);
//     }
//   };

//   // Handle File Selection Change
//   const handleFieldSelect = (
//     event: React.SyntheticEvent,
//     newValue: SelectedFileItem | null
//   ) => {
//     setSelectedItem(newValue);
//     setTableData(newValue?.member_DocFiles || []);
//     setPDFShow(null);
//     setSelectedRowData(null);
//   };

//   // Fetch Specific PDF Data by ID
//   const fetchPdfData = async (docMid: number) => {
//     setIsLoadingPdf(true);
//     setPDFShow(null);
//     const collectData = {
//       docMid: docMid,
//       fileTypId: 0,
//       divisionid: 0,
//       subsubjId: 0,
//       user_Id: 0,
//       fileNo: "",
//     };
//     try {
//       const response = await axios.post<{ data: any[] }>(
//         HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`,
//         collectData
//       );

//       if (
//         response?.data?.data &&
//         response.data.data.length > 0 &&
//         response.data.data[0]?.member_DocFiles &&
//         response.data.data[0].member_DocFiles.length > 0 &&
//         response.data.data[0].member_DocFiles[0]?.pdfPath
//       ) {
//         setPDFShow(response.data.data[0].member_DocFiles[0].pdfPath);
//       } else {
//         console.warn("PDF data not found in response for docMid:", docMid);
//         // Still using toast for info, but with hardcoded English text
//         toast.info("PDF data not found for this document.");
//         setPDFShow(null);
//       }
//     } catch (error) {
//       console.error("Error fetching PDF data:", error);
//        // Still using toast for errors, but with hardcoded English text
//       toast.error("Failed to fetch PDF data.");
//       setPDFShow(null);
//     } finally {
//       setIsLoadingPdf(false);
//     }
//   };

//   // Open Dialog Handler
//   const handleOpenDialog = (rowData: DocFile) => {
//     setSelectedRowData(rowData);
//     setOpenDialog(true);
//     fetchPdfData(rowData.docMid);
//   };

//   // Close Dialog Handler
//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setTimeout(() => {
//       setSelectedRowData(null);
//       setPDFShow(null);
//       setIsLoadingPdf(false);
//     }, 300);
//   };

//   const goBack = () => {
//     navigate(-1);
//   };

//   return (
//     <>
//       <CssBaseline />
//       <ToastApp />
//       <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
//         <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//             <IconButton onClick={goBack} color="primary">
//               <ArrowBackSharpIcon />
//             </IconButton>
//             <Typography variant="h5" component="h1" sx={{ ml: 1, fontWeight: 'medium' }}>
//               {/* Replaced t("text.DocViewer") */}
//               Document Viewer
//             </Typography>
//           </Box>

//           <Divider sx={{ mb: 3 }} />

//           <Grid container spacing={3}>
//             {/* File Selection */}
//             <Grid item xs={12}>
//               <Autocomplete
//                 disablePortal
//                 id="file-select-autocomplete"
//                 options={fileOptions}
//                 value={selectedItem}
//                 isOptionEqualToValue={(option, value) => option.value === value.value}
//                 getOptionLabel={(option) => option.label || ""}
//                 onChange={handleFieldSelect}
//                 loading={isLoadingFiles}
//                 fullWidth
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     // Replaced t("text.SelectField")
//                     label="Select File"
//                     variant="outlined"
//                     InputProps={{
//                       ...params.InputProps,
//                       endAdornment: (
//                         <>
//                           {isLoadingFiles ? <CircularProgress color="inherit" size={20} /> : null}
//                           {params.InputProps.endAdornment}
//                         </>
//                       ),
//                     }}
//                   />
//                 )}
//               />
//             </Grid>

//             {/* Document Table */}
//             {selectedItem && (
//               <Grid item xs={12}>
//                 <Typography variant="h6" gutterBottom sx={{ mb: 2, mt: 2 }}>
//                   {/* Replaced t('text.AssociatedDocuments') */}
//                   Associated Documents
//                 </Typography>
//                 <Paper variant="outlined" sx={{ width: '100%', overflow: 'hidden' }}>
//                   <TableContainer sx={{ maxHeight: 440 }}>
//                     <Table stickyHeader aria-label="document table">
//                       <TableHead>
//                         <TableRow>
//                           {/* Replaced t('tableHeader.pdfName') */}
//                           <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'grey.200' }}>PDF Name</TableCell>
//                           {/* Replaced t('tableHeader.keywords') */}
//                           <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'grey.200' }}>Keywords</TableCell>
//                           {/* Replaced t('tableHeader.entryDate') */}
//                           <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: 'grey.200' }}>Entry Date</TableCell>
//                           {/* Replaced t('tableHeader.subFileType') */}
//                           <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'grey.200' }}>Sub File Type</TableCell>
//                           {/* Replaced t('tableHeader.viewPdf') */}
//                           <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: 'grey.200' }}>View PDF</TableCell>
//                         </TableRow>
//                       </TableHead>
//                       <TableBody>
//                         {tableData.length > 0 ? (
//                           tableData.map((row) => (
//                             <TableRow
//                               hover
//                               key={row.docMid}
//                               sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
//                             >
//                               <TableCell component="th" scope="row">
//                                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                     <PictureAsPdfIcon sx={{ mr: 1, color: 'error.main' }} />
//                                     {row.pdfName}
//                                 </Box>
//                               </TableCell>
//                               <TableCell>{row.keywords}</TableCell>
//                               <TableCell align="center">
//                                 {dayjs(row.entryDate).isValid() ? dayjs(row.entryDate).format("DD-MM-YYYY") : 'N/A'}
//                               </TableCell>
//                               <TableCell>{row.subFtype}</TableCell>
//                               <TableCell align="center">
//                                 <IconButton
//                                   color="primary"
//                                    // Replaced t('button.viewPdf')
//                                   aria-label="View PDF"
//                                   onClick={() => handleOpenDialog(row)}
//                                 >
//                                   <VisibilityIcon />
//                                 </IconButton>
//                               </TableCell>
//                             </TableRow>
//                           ))
//                         ) : (
//                           <TableRow>
//                             <TableCell colSpan={5} align="center">
//                               <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3, color: 'text.secondary' }}>
//                                 <FindInPageIcon sx={{ mr: 1 }} />
//                                 {/* Replaced t('text.noRecordsAvailable') */}
//                                 <Typography>No Records Available</Typography>
//                               </Box>
//                             </TableCell>
//                           </TableRow>
//                         )}
//                       </TableBody>
//                     </Table>
//                   </TableContainer>
//                 </Paper>
//               </Grid>
//             )}
//           </Grid>
//         </Paper>

//         {/* PDF Viewer Dialog */}
//         <Dialog
//           fullScreen
//           open={openDialog}
//           onClose={handleCloseDialog}
//           TransitionComponent={Transition}
//           aria-labelledby="pdf-viewer-dialog-title"
//         >
//           <DialogTitle sx={{ m: 0, p: 2, backgroundColor: 'primary.main', color: 'white' }} id="pdf-viewer-dialog-title">
//              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
//                 <Typography variant="h6" component="div">
//                     {/* Replaced t('text.pdfViewerTitle') */}
//                     PDF Viewer - {selectedRowData?.pdfName || 'Document'}
//                 </Typography>
//                 <IconButton
//                 aria-label="close"
//                 onClick={handleCloseDialog}
//                 sx={{ color: 'white' }}
//                 >
//                  <CloseIcon />
//                 </IconButton>
//              </Box>
//           </DialogTitle>
//           <DialogContent dividers sx={{ p: 0,
//              backgroundColor: '#f7f7f7',
//              display: 'flex',
//              justifyContent: 'center',
//              alignItems: 'center',
//              overflow: 'hidden'
//              }}>
//             {isLoadingPdf ? (
//               <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
//                 <CircularProgress size={60} />
//                 {/* Replaced t('text.loadingPdf') */}
//                  <Typography sx={{ mt: 2 }}>Loading PDF...</Typography>
//               </Box>
//             ) : pdfShow ? (
//                  <Box sx={{ width: '100%', height: '100%', overflow: 'auto' }}>
//                      <Flipbook filePath={pdfShow} />
//                  </Box>
//             ) : (
//               <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', textAlign: 'center', p: 3 }}>
//                  <NoSimIcon sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
//                 <Typography variant="h6" color="text.secondary">
//                     {/* Replaced t('text.noPdfPreviewAvailable') as specifically requested */}
//                     No Pdf Preview Available
//                  </Typography>
//               </Box>
//             )}
//           </DialogContent>
//            {/* Optional: Add actions if needed later
//            <DialogActions>
//              <Button onClick={handleCloseDialog}>Close</Button>
//            </DialogActions> */}
//         </Dialog>
//       </Container>
//     </>
//   );
// };

// export default DocViewer;


import React, { useEffect, useState, forwardRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next"; // Removed as t() is no longer used for static text here
import { toast } from "react-toastify";
import {
  Container,
  Grid,
  TextField,
  Typography,
  Divider,
  Box,
  Autocomplete,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Slide,
  CssBaseline,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from "@mui/icons-material/Close";
import FindInPageIcon from '@mui/icons-material/FindInPage';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import NoSimIcon from '@mui/icons-material/NoSim';
import InfoIcon from '@mui/icons-material/Info';

import HOST_URL from "../../../utils/Url";
import ToastApp from "../../../ToastApp";
import dayjs from "dayjs";
import Flipbook from "./components/Flipbook";
import { getSecureDevId } from "../../../utils/storageHelpers";

// Define interface for table row data for better type safety
interface DocFile {
  docMid: number;
  pdfName: string;
  keywords: string;
  entryDate: string;
  subFtype: string;
  pdfPath?: string;
}

// Define interface for the selected item from Autocomplete
interface SelectedFileItem {
  label: string;
  value: number;
  member_DocFiles: DocFile[];
}

// Dialog Transition
const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type Props = {};

const DocViewer = (props: Props) => {
  // const { t } = useTranslation(); // Removed
  const navigate = useNavigate();

  const [fileOptions, setFileOptions] = useState<SelectedFileItem[]>([]);
  const [selectedItem, setSelectedItem] = useState<SelectedFileItem | null>(null);
  const [tableData, setTableData] = useState<DocFile[]>([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<DocFile | null>(null);
  const [pdfShow, setPDFShow] = useState<string | null>(null);
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);
  const [isLoadingPdf, setIsLoadingPdf] = useState(false);
  const [toaster, setToaster] = useState(false); // Assuming ToastApp uses this - keep if needed by ToastApp

const devId = getSecureDevId();


  // Fetch File List on Mount
  useEffect(() => {
    fetchFileList();
  }, []);

  const fetchFileList = async () => {
    setIsLoadingFiles(true);
    const collectData = {
      docMid: -1,
      fileTypId: -1,
      //@ts-ignore
      divisionid:devId === "null" ? -1 : devId,
      subsubjId: -1,
      user_Id: -1,
      fileNo: "",
    };
    try {
      const response = await axios.post<{ data: any[] }>(
        HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`,
        collectData
      );
      const formattedOptions = response.data.data.map((item: any) => ({
        label:item.fileNo ? `${item.fileNo} (${item.synopsis})` : "_ _",
        value: item.docMid,
        member_DocFiles: item.member_DocFiles || [],
      }));
      setFileOptions(formattedOptions);
    } catch (error) {
      console.error("Error fetching file list:", error);
      // Still using toast for errors, but with hardcoded English text
      toast.error("Failed to fetch file list.");
    } finally {
      setIsLoadingFiles(false);
    }
  };

  // Handle File Selection Change
  const handleFieldSelect = (
    event: React.SyntheticEvent,
    newValue: SelectedFileItem | null
  ) => {
    setSelectedItem(newValue);
    setTableData(newValue?.member_DocFiles || []);
    setPDFShow(null);
    setSelectedRowData(null);
  };

  // Fetch Specific PDF Data by ID
  const fetchPdfData = async (docMid: number) => {
    setIsLoadingPdf(true);
    setPDFShow(null);
    const collectData = {
      docMid: docMid,
      fileTypId: 0,
      divisionid: 0,
      subsubjId: 0,
      user_Id: 0,
      fileNo: "",
    };
    try {
      const response = await axios.post<{ data: any[] }>(
        HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`,
        collectData
      );

      if (
        response?.data?.data &&
        response.data.data.length > 0 &&
        response.data.data[0]?.member_DocFiles &&
        response.data.data[0].member_DocFiles.length > 0 &&
        response.data.data[0].member_DocFiles[0]?.pdfPath
      ) {
        setPDFShow(response.data.data[0].member_DocFiles[0].pdfPath);
      } else {
        console.warn("PDF data not found in response for docMid:", docMid);
        // Still using toast for info, but with hardcoded English text
        toast.info("PDF data not found for this document.");
        setPDFShow(null);
      }
    } catch (error) {
      console.error("Error fetching PDF data:", error);
       // Still using toast for errors, but with hardcoded English text
      toast.error("Failed to fetch PDF data.");
      setPDFShow(null);
    } finally {
      setIsLoadingPdf(false);
    }
  };

  // Open Dialog Handler (for Eye icon)
  const handleOpenDialog = (rowData: DocFile) => {
    setSelectedRowData(rowData);
    setOpenDialog(true);
    fetchPdfData(rowData.docMid);
  };

  // Handle Info icon click - Open PDF URL in new tab
  const handleInfoClick = (pdfPath: string) => {
    if (pdfPath) {
      window.open(pdfPath, '_blank', 'noopener,noreferrer');
    } else {
      toast.error("No PDF URL available");
    }
  };

  // Close Dialog Handler
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setTimeout(() => {
      setSelectedRowData(null);
      setPDFShow(null);
      setIsLoadingPdf(false);
    }, 300);
  };

  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      <CssBaseline />
      <ToastApp />
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <IconButton onClick={goBack} color="primary">
              <ArrowBackSharpIcon />
            </IconButton>
            <Typography variant="h5" component="h1" sx={{ ml: 1, fontWeight: 'medium' }}>
              {/* Replaced t("text.DocViewer") */}
              Document Viewer
            </Typography>
          </Box>

          <Divider sx={{ mb: 3 }} />

          <Grid container spacing={3}>
            {/* File Selection */}
            <Grid item xs={12}>
              <Autocomplete
                disablePortal
                id="file-select-autocomplete"
                options={fileOptions}
                value={selectedItem}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                getOptionLabel={(option) => option.label || ""}
                onChange={handleFieldSelect}
                loading={isLoadingFiles}
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    // Replaced t("text.SelectField")
                    label="Select File"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {isLoadingFiles ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            {/* Document Table */}
            {selectedItem && (
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom sx={{ mb: 2, mt: 2 }}>
                  {/* Replaced t('text.AssociatedDocuments') */}
                  Associated Documents
                </Typography>
                <Paper variant="outlined" sx={{ width: '100%', overflow: 'hidden' }}>
                  <TableContainer sx={{ maxHeight: 440 }}>
                    <Table stickyHeader aria-label="document table">
                      <TableHead>
                        <TableRow>
                          {/* Replaced t('tableHeader.pdfName') */}
                          <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'grey.200' }}>PDF Name</TableCell>
                          {/* Replaced t('tableHeader.keywords') */}
                          <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'grey.200' }}>Keywords</TableCell>
                          {/* Replaced t('tableHeader.entryDate') */}
                          <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: 'grey.200' }}>Entry Date</TableCell>
                          {/* Replaced t('tableHeader.subFileType') */}
                          <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'grey.200' }}>Sub File Type</TableCell>
                          {/* Replaced t('tableHeader.viewPdf') */}
                          <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: 'grey.200' }}>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tableData.length > 0 ? (
                          tableData.map((row) => (
                            <TableRow
                              hover
                              key={row.docMid}
                              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                              <TableCell component="th" scope="row">
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <PictureAsPdfIcon sx={{ mr: 1, color: 'error.main' }} />
                                    {row.pdfName}
                                </Box>
                              </TableCell>
                              <TableCell>{row.keywords}</TableCell>
                              <TableCell align="center">
                                {dayjs(row.entryDate).isValid() ? dayjs(row.entryDate).format("DD-MM-YYYY") : 'N/A'}
                              </TableCell>
                              <TableCell>{row.subFtype}</TableCell>
                              <TableCell align="center">
                                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                                  {/* Eye Icon - Opens 3D Flipbook Dialog */}
                                  <IconButton
                                    color="primary"
                                    // Replaced t('button.viewPdf')
                                    aria-label="View PDF in 3D Viewer"
                                    onClick={() => handleOpenDialog(row)}
                                    title="View in 3D Viewer"
                                  >
                                    <VisibilityIcon />
                                  </IconButton>
                                  
                                  {/* Info Icon - Opens PDF URL in New Tab */}
                                  <IconButton
                                    color="secondary"
                                    aria-label="Open PDF in new tab"
                                    onClick={() => handleInfoClick(row.pdfPath || '')}
                                    title="Open PDF in new tab"
                                    disabled={!row.pdfPath}
                                  >
                                    <InfoIcon />
                                  </IconButton>
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={5} align="center">
                              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3, color: 'text.secondary' }}>
                                <FindInPageIcon sx={{ mr: 1 }} />
                                {/* Replaced t('text.noRecordsAvailable') */}
                                <Typography>No Records Available</Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Grid>
            )}
          </Grid>
        </Paper>

        {/* PDF Viewer Dialog (3D Flipbook) */}
        <Dialog
          fullScreen
          open={openDialog}
          onClose={handleCloseDialog}
          TransitionComponent={Transition}
          aria-labelledby="pdf-viewer-dialog-title"
        >
          <DialogTitle sx={{ m: 0, p: 2, backgroundColor: 'primary.main', color: 'white' }} id="pdf-viewer-dialog-title">
             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <Typography variant="h6" component="div">
                    {/* Replaced t('text.pdfViewerTitle') */}
                    PDF Viewer - {selectedRowData?.pdfName || 'Document'}
                </Typography>
                <IconButton
                aria-label="close"
                onClick={handleCloseDialog}
                sx={{ color: 'white' }}
                >
                 <CloseIcon />
                </IconButton>
             </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ p: 0,
             backgroundColor: '#f7f7f7',
             display: 'flex',
             justifyContent: 'center',
             alignItems: 'center',
             overflow: 'hidden'
             }}>
            {isLoadingPdf ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <CircularProgress size={60} />
                {/* Replaced t('text.loadingPdf') */}
                 <Typography sx={{ mt: 2 }}>Loading PDF...</Typography>
              </Box>
            ) : pdfShow ? (
                 <Box sx={{ width: '100%', height: '100%', overflow: 'auto' }}>
                     <Flipbook filePath={pdfShow} />
                 </Box>
            ) : (
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', textAlign: 'center', p: 3 }}>
                 <NoSimIcon sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
                <Typography variant="h6" color="text.secondary">
                    {/* Replaced t('text.noPdfPreviewAvailable') as specifically requested */}
                    No Pdf Preview Available
                 </Typography>
              </Box>
            )}
          </DialogContent>
        </Dialog>
      </Container>
    </>
  );
};

export default DocViewer;